export const getTilesImages = (componentData) => {
    return {
        title: componentData?.fields?.title,
        tiles: componentData?.fields?.elements?.map((el) => {
            return {
                image: {
                    url: el?.fields?.image?.fields?.file?.url,
                    title: el?.fields?.image?.fields?.title
                },
            };
        }),
        gridColumns: componentData?.fields?.gridColumns,
        gridSpacing: componentData?.fields?.gridSpacing,
        backgroundColor: componentData?.fields?.backgroundColour,
        titleStyle: componentData?.fields?.titleStyle
    };
};
